import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Eye, EyeOff, LogIn } from 'lucide-react'

export function Login() {
  const { login }               = useAuth()
  const [usuario, setUsuario]   = useState('')
  const [senha, setSenha]       = useState('')
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [erro, setErro]         = useState('')
  const [loading, setLoading]   = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!usuario.trim() || !senha) { setErro('Preencha usuário e senha'); return }
    setLoading(true)
    setErro('')
    const result = await login(usuario.trim(), senha)
    if (result.erro) {
      setErro(result.erro)
      setSenha('')
    }
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-[#111111] flex flex-col items-center justify-center px-4">

      {/* Logo */}
      <div className="mb-8 text-center">
        <div className="inline-flex items-center gap-3 mb-3">
          <img src="/logo-mini.svg" alt="MINI DECK" className="h-14 w-14 rounded-xl object-contain" />
          <div className="text-left leading-none">
            <div className="text-white font-black text-3xl tracking-widest">MINI DECK</div>
            <div className="text-[#F5C200] font-semibold text-sm tracking-[0.3em] uppercase mt-1">
              Marcenaria
            </div>
          </div>
        </div>
        <p className="text-slate-500 text-sm">Sistema de Gestão de Pedidos</p>
      </div>

      {/* Card de login */}
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-lg font-bold text-[#111111] mb-6">Entrar no sistema</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">Usuário</label>
              <input
                value={usuario}
                onChange={e => { setUsuario(e.target.value); setErro('') }}
                className="input"
                placeholder="seu usuário"
                autoComplete="username"
                autoFocus
              />
            </div>

            <div>
              <label className="label">Senha</label>
              <div className="relative">
                <input
                  type={mostrarSenha ? 'text' : 'password'}
                  value={senha}
                  onChange={e => { setSenha(e.target.value); setErro('') }}
                  className="input pr-10"
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha(v => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors"
                >
                  {mostrarSenha ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {erro && (
              <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm text-red-600">
                {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full justify-center mt-2"
            >
              {loading ? (
                <span className="w-4 h-4 border-2 border-[#111]/30 border-t-[#111] rounded-full animate-spin" />
              ) : (
                <LogIn size={16} />
              )}
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <p className="text-center text-slate-600 text-xs mt-6">
          Acesso restrito · MINI DECK
        </p>
      </div>
    </div>
  )
}
